import { useEffect, useState, useRef } from 'react';
import { Modal } from 'react-bootstrap';

import {
    setDateTimeFormatGlobalString, isUndNullEmp, getLanguageObj, getResponse, getRolesType, handleResponseMessageAsync, settings, styles
} from '../../helpers/main';
import { GlobalFormats } from '../../classess/main/globalFormats';
import { DigitizedDocument } from '../../classess/main/digitizedDocument';
import parse from 'html-react-parser';

const { icons, images, labels } = settings;

const currentMethod = 'ServiceDocumentDetail';

export default function ServiceDocumentDetail({
    modalObj = {
        $: {},
        type: 0,
        auth: {},
        sdShowModal: false,
        languageObj: GlobalFormats?.getClass(getLanguageObj({ subMethod: currentMethod })?.result),
        dtServiceDocumentsId: '',
        dtServiceDocumentsRowId: 0,
        serviceDocument: DigitizedDocument?.getClass({}, false),
        userRoles: getRolesType(),
    },
    setModalObj = {},
}) {
    //#region variables
    const isMount = useRef(true);

    const sdFieldsObj = {
        company: {
            value: '',
        },
        item: {
            value: '',
        },
        emisionDate: {
            value: '',
        },
        service: {
            commentary: '',
            endDate: {
                value: '',
            },
            remainingDays: {
                class: '',
                value: 0,
            },
        },
    };
    const [sdFields, setSdFields] = useState(sdFieldsObj);
    const controls = {
        buttons: {
            back: {
                id: 'btnSdModalBack',
            },
            closeModal: {
                id: 'btnSdModalClose',
            },
        },
        icons: {
            back: {
                id: 'iconSdModalBack',
            },
        },
    };
    //#endregion variables

    //#region methods
    //#region datacenter
    //#endregion datacenter

    //#region others
    const getData = async ({
        subMethod = ''
    } = {}) => {
        const currentMethod = 'getData';
        let response = getResponse({ type: 0 });
        try {
            setSdFields(prev => ({
                ...prev,
                company: {
                    ...prev.company,
                    value: `${modalObj?.serviceDocument?.company?.name || ''}`,
                },
                emisionDate: {
                    ...prev.emisionDate,
                    value: setDateTimeFormatGlobalString({
                        date: modalObj?.serviceDocument?.emisionDate,
                        dateFormat: modalObj?.languageObj?.format?.date?.f1,
                        timeFormat: 0,
                        withSeconds: false,
                        languageId: modalObj?.languageObj?.id,
                        subMethod: currentMethod,
                    })?.result,
                },
                item: {
                    ...prev.item,
                    value: `${modalObj?.serviceDocument?.item?.id || ''} - ${modalObj?.serviceDocument?.item?.description || ''}`,
                },
                service: {
                    ...prev.service,
                    commentary: modalObj?.serviceDocument?.service?.commentary?.replaceAll('\r', '<br/>')?.replaceAll('\t', settings?.react?.html?.spaces?.one) || '',
                    endDate: {
                        ...prev.service.endDate,
                        value: setDateTimeFormatGlobalString({
                            date: modalObj?.serviceDocument?.service?.endDate,
                            dateFormat: modalObj?.languageObj?.format?.date?.f1,
                            timeFormat: 0,
                            withSeconds: false,
                            languageId: modalObj?.languageObj?.id,
                            subMethod: currentMethod,
                        })?.result,
                    },
                    remainingDays: {
                        ...prev.service.remainingDays,
                        class: (modalObj?.serviceDocument?.service?.remainingDays >= 15) ? 'text-success' :
                            (modalObj?.serviceDocument?.service?.remainingDays >= 1 && modalObj?.serviceDocument?.service?.remainingDays < 15) ? 'text-warning' : 'text-danger',
                        value: modalObj?.serviceDocument?.service?.remainingDays || 0,
                    },
                },
            }));
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        } finally {
            if (!isMount?.current) return;
            // CSN:
            if (!response?.isSuccess || response?.isWarning || response?.msgText !== '' || response?.msgTextHtml !== '') {
                await handleResponseMessageAsync({
                    response,
                    currentMethod,
                    auth: modalObj?.auth,
                    languageId: modalObj?.languageObj?.id
                });
            }
        }
    }

    const setDefaultValue = ({
        closeModal = false,
        subMethod = '',
    } = {}) => {
        const currentMethod = 'setDefaultValue';
        let response = getResponse({ type: 0 });
        try {
            if (closeModal) {
                setModalObj(prev => ({
                    ...prev,
                    sdShowModal: false,
                    type: 0,
                }));
            }
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
            console?.error(response?.msgText);
        }
    }

    useEffect(() => {
        isMount.current = true;
        getData({ subMethod: 'form - onLoad' });
        return () => { isMount.current = false; };
    }, []);// eslint-disable-line react-hooks/exhaustive-deps
    //#endregion others
    //#endregion methods

    return (
        <Modal backdrop='static' show={modalObj?.sdShowModal} scrollable centered>
            <Modal.Header className='border-bottom-0 pt-4 px-4 bg-white'>
                <Modal.Title className='d-flex align-items-center w-100'>
                    <div className='bg-light p-2 rounded-circle mr-3 shadow-sm'
                        style={{ width: '45px', height: '45px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <img alt='dataCenters' src={images?.icons?.dataCenters} style={{ ...styles?.cardHeaderLogo }} />
                    </div>
                    <div className='d-flex flex-column'>
                        <span className='h5 mb-0 font-weight-bold text-dark'>{labels?.serviceDocument[modalObj?.languageObj?.id]}</span>
                        <div className='d-flex align-items-center mt-1'>
                            <span className='badge badge-pill badge-info py-1 px-2 text-uppercase' style={settings?.html?.badges?.micro}>
                                <i className={`${icons?.fasFa?.infoCircle} mr-1`} />
                                {modalObj?.type === 0 ? labels?.add?.[modalObj?.languageObj?.id] :
                                    modalObj?.type === 1 ? labels?.edit?.[modalObj?.languageObj?.id] :
                                        labels?.detail?.[modalObj?.languageObj?.id] || 'Detail'}
                            </span>
                        </div>
                    </div>
                </Modal.Title>
                <button id={controls?.buttons?.closeModal?.id}
                    className='close border-0 bg-transparent'
                    data-dismiss='modal'
                    aria-label='Close'
                    style={{ fontSize: '1.5rem', marginTop: '-15px' }}
                    onClick={() => setDefaultValue({ closeModal: true, subMethod: '', })}>
                    <span aria-hidden='true'>&times;</span>
                </button>
            </Modal.Header>
            <Modal.Body className='p-0'>
                <form onSubmit={(e) => e.preventDefault()}>
                    <div className='card-body p-4'>
                        {/* Seccion de Cabecera: Empresa y Fecha Expiracion */}
                        <div className='row mb-2'>
                            <div className='col-12 col-md-7 mb-3'>
                                <div className='p-3 bg-light border-left border-success shadow-sm h-100' style={{ borderRadius: '10px', borderLeftWidth: '5px' }}>
                                    <small className='text-muted text-uppercase font-weight-bold d-block mb-1' style={settings?.html?.labels?.detailMicro}>
                                        <i className={icons?.fasFa?.building || 'fas fa-building'} /> {labels?.company?.[modalObj?.languageObj?.id]}
                                    </small>
                                    <h5 className='text-primary mb-0 font-weight-bold text-truncate' title={sdFields?.company?.value}>
                                        {sdFields?.company?.value || '---'}
                                    </h5>
                                </div>
                            </div>
                            <div className='col-12 col-md-5 mb-3'>
                                <div className='p-3 bg-light border-left border-info shadow-sm h-100' style={{ borderRadius: '10px', borderLeftWidth: '5px' }}>
                                    <small className='text-muted text-uppercase font-weight-bold d-block mb-1' style={settings?.html?.labels?.detailMicro}>
                                        <i className={icons?.faFa?.calendarAlt || 'fas fa-calendar-alt'} /> {labels?.expiration?.[modalObj?.languageObj?.id]}
                                    </small>
                                    <h5 className='mb-0 font-weight-bold'>
                                        {sdFields?.service?.endDate?.value || '---'}
                                    </h5>
                                </div>
                            </div>
                        </div>

                        {/* Fila Central: Detalles Técnicos y Status */}
                        <div className='row mb-2 text-center'>
                            <div className='col-12 col-md-3 mb-3 border-md-right'>
                                <small className='text-muted d-block' style={settings?.html?.labels?.detailMicro}>
                                    <i className={icons?.fasFa?.cog || 'fas fa-cog'} /> {labels?.type?.[modalObj?.languageObj?.id]}
                                </small>
                                <span className='font-weight-bold text-dark'>{modalObj?.serviceDocument?.type || '---'}</span>
                            </div>
                            <div className='col-12 col-md-3 mb-3 border-md-right'>
                                <small className='text-muted d-block' style={settings?.html?.labels?.detailMicro}>
                                    <i className={icons?.fasFa?.hashtag || 'fas fa-hashtag'} /> {labels?.document?.[modalObj?.languageObj?.id]}
                                </small>
                                <span className='badge badge-secondary px-2' style={settings?.html?.badges?.micro}>
                                    {modalObj?.serviceDocument?.number || 0}
                                </span>
                            </div>
                            <div className='col-12 col-md-3 mb-3 border-md-right'>
                                <small className='text-muted d-block' style={settings?.html?.labels?.detailMicro}>
                                    <i className={icons?.faFa?.calendarAlt || 'fas fa-calendar-alt'} /> {labels?.date?.[modalObj?.languageObj?.id]}
                                </small>
                                <span className='font-weight-bold text-dark text-sm'>{sdFields?.emisionDate?.value || '---'}</span>
                            </div>
                            <div className='col-12 col-md-3 mb-3'>
                                <small className='text-muted d-block mb-1' style={settings?.html?.labels?.detailMicro}>
                                    <i className={icons?.fasFa?.hourglassHalf || 'fas fa-hourglass-half'} /> {labels?.daysToExpireAbr2?.[modalObj?.languageObj?.id]}
                                </small>
                                <span className={`badge ${sdFields?.service?.remainingDays?.class} px-3 py-1 shadow-xs`} style={{ fontSize: '1rem' }}>
                                    {sdFields?.service?.remainingDays?.value}
                                </span>
                            </div>
                        </div>

                        <hr className='my-2' />

                        {/* Seccion de Item y Producto */}
                        <div className='mb-4 mt-3'>
                            <small className='text-muted d-block font-weight-bold mb-2' style={settings?.html?.labels?.detailMicro}>
                                <i className={icons?.fasFa?.list || 'fas fa-list'} /> {labels?.item?.[modalObj?.languageObj?.id]}
                            </small>
                            <div className='p-3 bg-light rounded border-left border-secondary shadow-sm' style={{ borderRadius: '10px', borderLeftWidth: '5px' }}>
                                <span className='text-muted font-italic'>{sdFields?.item?.value || '---'}</span>
                            </div>
                        </div>

                        {/* Seccion de Comentarios Estilizada */}
                        <div className='mb-1'>
                            <small className='text-muted d-block font-weight-bold mb-2' style={settings?.html?.labels?.detailMicro}>
                                <i className={icons?.fasFa?.edit || 'fas fa-edit'} /> {labels?.commentary?.[modalObj?.languageObj?.id]}
                            </small>
                            <div className='p-3 rounded bg-white border-left border-primary shadow-sm' style={{ minHeight: '100px', borderLeftWidth: '5px', fontSize: '0.95rem', lineHeight: '1.6', overflowWrap: 'break-word' }}>
                                {parse(sdFields?.service?.commentary || '---')}
                            </div>
                        </div>
                    </div>
                </form>
            </Modal.Body>
            <Modal.Footer className='border-top-0 pb-4 px-4 bg-white'>
                <div className='d-flex justify-content-center w-100'>
                    <button id={controls?.buttons?.back?.id}
                        className='btn btn-outline-secondary shadow-sm font-weight-bold mx-1 px-4'
                        style={{ borderRadius: '5px' }}
                        title={labels?.close?.[modalObj?.languageObj?.id]}
                        type='reset'
                        onClick={() => setDefaultValue({ closeModal: true, subMethod: controls?.buttons?.back?.id })}>
                        <i id={controls?.icons?.back?.id} className={icons?.fasFa?.arrowCircleLeft || 'fas fa-arrow-circle-left'} /> {labels?.back?.[modalObj?.languageObj?.id]}
                    </button>
                </div>
            </Modal.Footer>
        </Modal>
    )
}